import React from 'react';

interface CustomSelectProps {
    id: string;
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    required?: boolean;
    disabled?: boolean;
    children: React.ReactNode;
}


export const CustomSelect: React.FC<CustomSelectProps> = ({ id, label, value, onChange, required = false, disabled = false, children }) => {
    return (
        <div className="form-group product-group">
            <label htmlFor={id}>{label}</label>
            <select
                id={id}
                value={value}
                onChange={onChange}
                required={required}
                disabled={disabled}
                autoComplete="off"
            >
                {children}
            </select>
        </div>
    );
};
